import { KeyCode } from '@common/constants/general/key-codes';

export const preventDefaultEnter = (event: any) => {
  if (event.keyCode === KeyCode.Enter) {
    event.preventDefault();
  }
};
